__turbopack_context__.v({
  "close": "index-module-scss-module__3EZGYq__close",
  "container": "index-module-scss-module__3EZGYq__container",
  "modal": "index-module-scss-module__3EZGYq__modal",
  "overlay": "index-module-scss-module__3EZGYq__overlay",
  "wrapper": "index-module-scss-module__3EZGYq__wrapper",
});
